import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import './Algorithms.css'
import { Link } from 'react-router-dom'
import { auth, database } from './firebase';
import logo from './images/semicolon.png'

function String() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className='algorithms-container'>
        <Navbar />
        <div className='logo-container'>
          <Link to='/'>
          <img src={logo} className='logo' alt='logo' />
          </Link>
        </div>
        <div className='message'>
          <h1>
            SORRY !
          </h1>
          <p>
          Dear mobile user, we know you like convenience, but trust us when we say the desktop experience of this web app will blow your tiny mobile mind. Don't settle for less switch to desktop view and unleash your awesome powers!
          </p>
        </div>
        {loggedIn ? (
        <div className='algo-hide'>
          <div className='algo_tb'>
              <p>Problem</p>
              <p>Difficulty</p>
          </div>
          <div className='prob_diff'>
              <div className='algorithms'>
                  <Link to='/problems/reverse-words-string' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Reverse Words in a String') ? 'submitted' : ''}`}>Reverse Words in a String</p>
                  </Link>
                  <Link to='/problems/string-palindrome' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'String Palindrome Check') ? 'submitted' : ''}`}>String Palindrome Check</p>
                  </Link>
                  <Link to='/problems/vowels-consonants' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Count Vowels and Consonants') ? 'submitted' : ''}`}>Count Vowels and Consonants</p>
                  </Link>
                  <Link to='/problems/rmv-duplicates' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Remove Duplicates') ? 'submitted' : ''}`}>Remove Duplicates</p>
                  </Link>
                  <Link to='/problems/string-compression' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'String Compression') ? 'submitted' : ''}`}>String Compression</p>
                  </Link>
                  <Link to='/problems/longest-substring' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Longest Substring Without Repeating Characters') ? 'submitted' : ''}`}>Longest Substring Without Repeating Characters</p>
                  </Link>
                  <Link to='/problems/grp-anagrams' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Group Anagrams') ? 'submitted' : ''}`}>Group Anagrams</p>
                  </Link>
                  <Link to='/problems/zigzag-conv' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'ZigZag Conversion') ? 'submitted' : ''}`}>ZigZag Conversion</p>
                  </Link>
                  <Link to='/problems/re-matching' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Regular Expression Matching') ? 'submitted' : ''}`}>Regular Expression Matching</p>
                  </Link>
                  <Link to='/problems/min-window-substring' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Minimum Window Substring') ? 'submitted' : ''}`}>Minimum Window Substring</p>
                  </Link>
              </div>
              <div className='diff'>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Hard</p>
                  <p>Hard</p>
              </div>
          </div>
        </div>
        ) : (
          <div>
            <h2>Please sign up/login to see this page</h2>
          </div>
        )}
    </div>
  )
}

export default String